/*
 * Copyright (c) 2022. Revo Digital
 * ---
 * Author: gabriele
 * File: TextAreaShapeControl.ts
 * Project: mle-client-n
 * Committed last: 2022/1/21 @ 1034
 * ---
 * Description:
 */

import { ShapeControl, ShapeControlInitParams } from './ControlGroup';
import {
  ControlTypes
}                                               from '../../selection-properties';

export class TextAreaShapeControl extends ShapeControl<string> {
  public placeholder?: string;
  public onTextChange?: (text: string) => void;

  constructor(initParams: ShapeControlInitParams<string>, { placeholder }: { placeholder: string }) {
    super(initParams);
    this.controlType = ControlTypes.RICH_TEXT;
    this.placeholder = placeholder;
  }
}